var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dialog"},[_c('div',{staticClass:"dialog_detail"},[_c('div',{staticClass:"dialog_title"},[_vm._v("这是报名场控")]),_c('img',{attrs:{"src":_vm.applyDate.popImageUrl,"alt":""}}),_c('div',{staticClass:"dialog_btn",on:{"click":_vm.close}},[_vm._v("关闭")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }